/* eslint-disable no-return-await */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable no-unused-expressions */
import { Component } from 'react';
import { Box } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import FormContainer from '../../../../FormContainer/FormContainer';
import LoaderComponent from '../../../../Utilities/LoaderComponent';
import { stateSuppressionState } from '../defaultState/state';
import { handleFormObjectChange } from '../../../../Utilities/HandleFormObjectChange';
import { NetworkRequest } from '../../../../Utilities/NetworkRequests/NetworkRequests';
import { formatSubmitValues } from '../../../../Utilities/SubmitHelper/FormatForSubmit';
import { validateForSubmit } from '../../../../Utilities/ValidationHelper/ValidateForm';
import { expectArrayData } from '../../../../common/commonRequests';
import { formatAffiliateValue } from '../../../../Utilities/getAffiliateIDFromName';
import { buildFormFields } from '../../../../Utilities/formHelper';

const styles = ({ breakpoints }) => ({
  form: {
    position: 'relative',
    [breakpoints.down(960)]: {
      '#formContainer': {
        flexDirection: 'column',
        '& > *': {
          width: '100%'
        }
      }
    }
  },
  loader: {
    position: 'absolute',
    zIndex: '1',
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
    width: '100%',
    height: '100%',
    left: 0,
    top: 0
  },
  hr: { margin: '1rem' },
  header: {
    textAlign: 'center'
  }
});

class StateSuppression extends Component {
  state = {
    formValues: stateSuppressionState(this.props),
    submitting: false,
    dialog: {
      message: '',
      type: 'error',
      title: 'Error'
    }
  };

  componentDidMount() {
    if (this.props.detailsView) {
      this.modifyHidden(false);
      this.getStatesDenylisted();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.detailsView) {
      if (
        this.state.formValues.affiliateID.value !==
        prevState.formValues.affiliateID.value
      ) {
        this.getStatesDenylisted();
      }
    }
  }

  handleChange = async (field, value) => {
    const formValues = handleFormObjectChange(field, value, {
      ...this.state.formValues
    });
    this.setState({ formValues });
    field !== 'states_map' && (await this.handleShowMap());
  };

  handleChangeDetailsView = async (field, value) => {
    if (field !== 'affiliateID' && field !== 'states_map') return;

    const formValues = {
      ...this.state.formValues,
      [field]: {
        ...this.state.formValues[field],
        value
      },
      buyer: {
        ...this.state.formValues.buyer,
        value: this.props.buyer
      },
      site: {
        ...this.state.formValues.site,
        value: this.props.site
      }
    };

    this.setState({ formValues });
    if (field !== 'states_map') {
      await this.handleShowMap();
    }
  };

  toggleDialog = (message = '', type = 'error', title = 'Error') =>
    this.setState({
      dialog: { ...this.state.dialog, message, type, title }
    });

  handleSubmit = () => {
    const { valid, messages } = validateForSubmit(this.state.formValues);
    if (!valid) {
      this.toggleDialog(messages, 'error');
      return false;
    }
    this.handleSubmitRequest();
  };

  handleSubmitRequest = () => {
    const modifiedFormValues = this.props.detailsView
      ? this.modifyValuesForSubmitDetailView()
      : this.modifyValuesForSubmit();
    this.setState({ submitting: true }, () =>
      NetworkRequest(
        'statesDenylist',
        formatSubmitValues(modifiedFormValues),
        'updateStatesDenylist'
      )
        .then(({ data }) => this.handleResponse(data))
        .catch(() => this.setState({ submitting: false }))
    );
  };

  handleResponse = (data) => {
    this.setState({ submitting: false }, () =>
      this.toggleDialog(
        data.success
          ? 'State Suppression successfully updated'
          : 'An error has happened',
        data.success ? 'success' : 'error',
        data.success ? 'Success' : 'Error'
      )
    );
  };

  modifyValuesForSubmitDetailView = () => {
    const { formValues } = this.state;
    return {
      ...formValues,
      site: {
        value: this.props.site
      },
      buyer: {
        value: this.props.buyer
      },
      affiliateID: {
        ...formValues.affiliateID,
        value: formatAffiliateValue(formValues.affiliateID.value)
      },
      states_map: {
        ...formValues.states_map,
        value: formValues.states_map.value.slice(0, -2)
      }
    };
  };

  modifyValuesForSubmit = () => {
    const { formValues } = this.state;
    return {
      ...formValues,
      affiliateID: {
        ...formValues.affiliateID,
        value: formatAffiliateValue(formValues.affiliateID.value)
      },
      states_map: {
        ...formValues.states_map,
        value: formValues.states_map.value.slice(0, -2)
      }
    };
  };

  getStatesDenylisted = async () => {
    this.setState(
      { submitting: true },
      async () =>
        await NetworkRequest(
          'statesDenylist',
          formatSubmitValues(
            this.props.detailsView
              ? this.modifyValueForGetDenylistDetailView()
              : this.modifyValueForGetDenylist()
          ),
          'getStatesDenylist'
        )
          .then(({ data }) => this.handleColorMap(data))
          .catch(() => this.setState({ submitting: false }))
    );
  };

  modifyValueForGetDenylistDetailView = () => {
    const { formValues } = this.state;
    return {
      ...formValues,
      buyer: {
        value: this.props.buyer
      },
      affiliateID: {
        ...formValues.affiliateID,
        value: formatAffiliateValue(formValues.affiliateID.value)
      },
      site: {
        value: this.props.site
      }
    };
  };

  modifyValueForGetDenylist = () => {
    const { formValues } = this.state;
    return {
      ...formValues,
      affiliateID: {
        ...formValues.affiliateID,
        value: formatAffiliateValue(formValues.affiliateID.value)
      }
    };
  };

  handleColorMap = (data) => {
    let statesString = '';
    expectArrayData(data).map((state) => {
      statesString += `${state}, `;
      return true;
    });
    this.setState({
      formValues: {
        ...this.state.formValues,
        states_map: {
          ...this.state.formValues.states_map,
          value: statesString
        }
      }
    });
    this.setState({ submitting: false });
  };

  handleShowMap = async () => {
    const showMap = this.mustShowMap();
    showMap && (await this.getStatesDenylisted());
    const newFormValue = this.modifyHidden(!showMap);
    this.setState({ formValues: newFormValue });
  };

  mustShowMap = () => {
    const {
      formValues: {
        affiliateID: { value: affiliate, defaultVal: defaultAff },
        buyer: { value: buyer, defaultVal: defaultBuyer }
      }
    } = this.state;

    return affiliate !== defaultAff && buyer !== defaultBuyer;
  };

  modifyHidden = (hideMap) => ({
    ...this.state.formValues,
    states_map: {
      ...this.state.formValues.states_map,
      hidden: hideMap
    }
  });

  render() {
    const { formValues, submitting, dialog } = this.state;
    const { loader, form } = this.props.classes;
    const { detailsView, classes } = this.props;

    return (
      <Box className={form}>
        {submitting && (
          <Box className={loader}>
            <LoaderComponent padding={150} />
          </Box>
        )}

        {detailsView && (
          <>
            <hr className={classes.hr} />
            <h3 className={classes.header}>State Suppression</h3>
          </>
        )}

        <FormContainer
          formValues={buildFormFields(formValues, this.state)}
          submitting={submitting}
          handleChange={
            detailsView ? this.handleChangeDetailsView : this.handleChange
          }
          handleSubmit={this.handleSubmit}
          inputWidth={8}
          separateBlock
          dialog={dialog}
          toggleDialog={this.toggleDialog}
        />
      </Box>
    );
  }
}

export default withStyles(StateSuppression, styles);
